import React, {PureComponent} from 'react';
import PhotosPicker from 'shared/components/PhotosPicker';
import AbstractListerField from './AbstractListerField';
import {FIELD_NAMES, SHOW_MODES, MAX_PHOTOS_ALLOWED, MAX_DESCRIPTION_URLS} from '../consts';
import connectWithRouter from 'shared/components/redux/connectWithRouter';
import _ from 'lodash';
import {
  getUpdatedEbayListingValues,
  getOriginalValues,
  getUpdatedFieldValue,
  getPhotosUnion,
  getPhotosInOtherNotInEbay,
  getPhotosInEbayNotInOther,
} from 'MyAccount/Listings/EbayListing/ebayListingSelectors';
import {getEbayAndVariationUrls} from '../ebayListingSelectors';
import {updateDescriptionPhotos} from 'MyAccount/Listings/listingsHelper';

@connectWithRouter(state => {
  return {
    site: _.get(getUpdatedEbayListingValues(state), FIELD_NAMES.EBAY_SITE),
    originalValues: getOriginalValues(state),
    descriptionGalleryUrls: getUpdatedFieldValue(state, FIELD_NAMES.CL_PICTURE_URLS) || [],
    ebayGalleryUrls: _.get(getUpdatedEbayListingValues(state), FIELD_NAMES.PICTURE_URL) || [],
    ebayWithVariationsUrls: getEbayAndVariationUrls(state) || [],
  };
})
export default class ListerPhotosPicker extends PureComponent {
  componentDidUpdate(prevProps) {
    if (this.props.fieldName === FIELD_NAMES.CL_PICTURE_URLS) {
      const {descriptionGalleryUrls, ebayWithVariationsUrls} = this.props;
      if (
        prevProps.showModeClicked !== SHOW_MODES.SHOW_ALL &&
        this.props.showModeClicked === SHOW_MODES.SHOW_ALL &&
        !_.isEmpty(ebayWithVariationsUrls)
      ) {
        this.onChange(getPhotosUnion(ebayWithVariationsUrls, descriptionGalleryUrls));
      } else if (
        prevProps.showModeClicked !== SHOW_MODES.SHOW_NONE &&
        this.props.showModeClicked === SHOW_MODES.SHOW_NONE
      ) {
        this.onChange(getPhotosInOtherNotInEbay(ebayWithVariationsUrls, descriptionGalleryUrls));
      }
    }
  }

  onChange = (value, reorder = false, deletion = false, pictureUploaded = false) => {
    const {onChange, onFieldDelete, showMode, ebayGalleryUrls, fieldName} = this.props;
    let {descriptionGalleryUrls} = this.props;
    if (fieldName === FIELD_NAMES.PICTURE_URL) {
      if (_.isEmpty(value)) {
        onFieldDelete();
      }
      if (deletion) {
        descriptionGalleryUrls = updateDescriptionPhotos(
          showMode,
          descriptionGalleryUrls,
          reorder,
          getPhotosInEbayNotInOther(ebayGalleryUrls, value),
          null
        );
      } else {
        descriptionGalleryUrls = updateDescriptionPhotos(showMode, descriptionGalleryUrls, reorder, null, value);
      }
      value = {
        ...(!_.isEmpty(value) && {[FIELD_NAMES.PICTURE_URL]: value}),
        [FIELD_NAMES.CL_PICTURE_URLS]: descriptionGalleryUrls,
      };
    } else if (fieldName === FIELD_NAMES.CL_PICTURE_URLS) {
      const {ebayWithVariationsUrls} = this.props;
      if (pictureUploaded) {
        // insert as main photo
        const lastElement = _.last(value);
        value = _.concat(lastElement, _.dropRight(value));
      } else if (deletion && _.size(descriptionGalleryUrls) > MAX_DESCRIPTION_URLS) {
        const urlToDelete = _.difference(descriptionGalleryUrls, value)[0];
        if (_.includes(ebayWithVariationsUrls, urlToDelete)) {
          const noEbayOrVariationsURLsCount = _.size(descriptionGalleryUrls) - _.size(ebayWithVariationsUrls);
          const urlsToDelete = _.slice(ebayWithVariationsUrls, MAX_DESCRIPTION_URLS - noEbayOrVariationsURLsCount - 1);
          _.pullAll(value, urlsToDelete);
        }
      }
    }
    onChange(value);
  };

  getPhotosAmountLeft() {
    const {fieldName, value, ebayWithVariationsUrls} = this.props;
    if (fieldName === FIELD_NAMES.PICTURE_URL) {
      return MAX_PHOTOS_ALLOWED - _.size(value[FIELD_NAMES.PICTURE_URL]);
    } else if (fieldName === FIELD_NAMES.CL_PICTURE_URLS) {
      return MAX_DESCRIPTION_URLS - _.size(getPhotosInOtherNotInEbay(ebayWithVariationsUrls, value));
    }
    return undefined;
  }

  render() {
    const {fieldName, value, id, ...other} = this.props;
    const photosAmountLeft = this.getPhotosAmountLeft();
    return (
      <PhotosPicker
        id={id}
        picturesURLs={_.isPlainObject(value) ? value[fieldName] : value}
        photosAmountLeft={photosAmountLeft}
        maxPhotosAllowed={fieldName === FIELD_NAMES.CL_PICTURE_URLS ? MAX_DESCRIPTION_URLS : MAX_PHOTOS_ALLOWED}
        updatePicturesURLs={this.onChange}
        uniqueIdForUploadDialog={`Lister_Photos_Picker_-${this.props.buttonLabel}`}
        {...other}
      />
    );
  }
}

_.assign(ListerPhotosPicker.contextTypes, AbstractListerField.contextTypes);
